"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { component } from "@gnist/component-utils";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { TextContainer } from "../../../foundation/typography/index.js";
import { useTranslation } from "../../../translations/index.js";
import classNames from "classnames";
import "../../actions/buttons/PrimaryButton.js";
import "../../actions/buttons/SecondaryButton.js";
import "../../actions/buttons/SuccessButton.js";
import "../../actions/buttons/DangerButton.js";
import "../../actions/buttons/GhostButton.js";
import { TextButton } from "../../actions/buttons/TextButton.js";
import { IconButton } from "../../actions/buttons/IconButton.js";
import { bannerHeading, icon, mainContentContainer, closeButton, messageContainer, actionButton, banner } from "./AlertBanner.css.js";
const BannerHeading = component("BannerHeading", bannerHeading, "h2");
const AlertBanner = ({ type, heading, message, dismiss, action, density = "default", headingLevel = "h2", className }) => {
  const text = useTranslation((t) => t.components.feedback.alerts);
  return jsxs("div", { className: classNames(className, banner({ type, density })), children: [jsx(Icon, { type, icon: type, className: icon({ type }) }), jsxs("div", { className: mainContentContainer({ density }), children: [heading && jsx(BannerHeading, { "$as": headingLevel, children: heading }), dismiss && jsx(IconButton, { className: closeButton, icon: "close", label: text.dismissLabel, onClick: dismiss }), typeof message === "string" ? jsx(TextContainer, { className: messageContainer, children: message }) : jsx("div", { className: messageContainer, children: message }), action && jsx(TextButton, { density: "compact", className: actionButton, onClick: action.onClick, underline: true, children: action.label })] })] });
};
export {
  AlertBanner
};
